import React from "react";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { Card, Tooltip } from "@mui/material";
import { ReactComponent as AndModeIcon } from "../../../../../../assets/images/AndMode.svg";

const SideRecipeCard = ({
  recipe,
  onEdit,
  onDelete,
  onToggleMode,
  setSearchParams,
  searchParams,
  setSelectedItem,
  scheduleKey,
  recipeIndex,
}) => {
  const isAndMode = recipe.toggleMode === "AND";

  const handleToggleMode = (e) => {
    e.stopPropagation();
    const newToggleMode = isAndMode ? "OR" : "AND";
    onToggleMode(recipeIndex, newToggleMode);
  };

  const handleEditRecipe = () => {
    setSelectedItem({ ...recipe, scheduleKey, recipeIndex });

    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "make_diet_plan");
    newParams.set("mode", "edit_recipe");
    newParams.set("recipeId", recipe.id);

    setSearchParams(newParams);
  };
  return (
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: "sm",
        mb: 1,
        px: 1,
        py: 0.5,
        cursor: "pointer",
      }}
      onClick={() => handleEditRecipe(recipe.id)}
    >
      <SuiBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
      >
        {recipe.image ? (
          <SuiBox
            component="img"
            sx={{
              objectFit: "cover",
              borderRadius: 1,
              width: 48,
              height: 48,
              flexShrink: 0,
            }}
            src={recipe.image}
            alt={recipe.name}
          />
        ) : (
          <SuiBox
            sx={{
              width: 48,
              height: 48,
              borderRadius: 1,
              backgroundColor: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              fontWeight: 600,
              color: "#888",
              textTransform: "uppercase",
              flexShrink: 0,
            }}
          >
            {recipe.name
              .split(" ")
              .slice(0, 2)
              .map((word) => word.charAt(0))
              .join("")}
          </SuiBox>
        )}

        <SuiBox
          flex={1}
          overflow="hidden"
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <SuiTypography
            variant="button"
            fontWeight="bold"
            color="text"
            sx={{
              lineHeight: 1.2,
              fontSize: "12px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textTransform: "capitalize",
            }}
          >
            {recipe.name}
          </SuiTypography>
          <SuiTypography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: "11px" }}
          >
            🔥 {isNaN(recipe.calories) ? "0" : recipe.calories} Cal
          </SuiTypography>
        </SuiBox>

        {/* Action Buttons */}
        <SuiBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={0.5}
        >
          <Tooltip
            title={
              isAndMode
                ? "You are expected to consume all the listed recipes."
                : "You can choose one recipe to consume from the list."
            }
            placement="top"
            arrow
          >
            <IconButton
              onClick={handleToggleMode}
              disableRipple
              sx={{
                bgcolor: isAndMode ? "#F57C00" : "#FFF3E0",
                color: isAndMode ? "#fff" : "#F57C00",
                p: "2px",
                borderRadius: "6px",
                width: "26px",
                height: "26px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  bgcolor: isAndMode ? "#E65100" : "#FFE0B2",
                },
                svg: {
                  width: "16px",
                  height: "16px",
                },
              }}
            >
              <AndModeIcon />
            </IconButton>
          </Tooltip>

          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete(recipeIndex);
            }}
            sx={{
              bgcolor: "#FFF3E0",
              color: "#F57C00",
              p: "2px",
              borderRadius: "6px",
              width: "26px",
              height: "26px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": { bgcolor: "#FFCDD2" },
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </SuiBox>
      </SuiBox>
    </Card>
  );
};

export default SideRecipeCard;
